import { ProductSortConfig } from '@aboutyou/backbone/endpoints/products/products'
import { ProductSortingIdType, SortingChannels } from 'constants/sorting'
import { mapSortValues } from 'helpers/sort'
import { IService } from 'services'
import { PRODUCT_TILE_SET, ProductSetId } from 'services/sets/product'
import Product from 'store/entities/Product/Product.store'
import { SelectedLooseFilterMapType } from 'store/sidecar/FilterViewStore'

export const createProductStreamFetcher = ({
  service,
  categoryId,
  filter,
  sortId,
  sortChannel,
  score,
  onError,
  productTileSet = PRODUCT_TILE_SET,
  forceAddProducts,
}: {
  service: IService
  categoryId: string
  filter?: SelectedLooseFilterMapType
  sortId: ProductSortingIdType
  sortChannel: SortingChannels
  score: ProductSortConfig['score']
  onError?: (e: Error) => void
  productTileSet?: ProductSetId
  forceAddProducts?: boolean
}) => {
  const sortingValues = mapSortValues(sortId)

  return async ({ perPage, page = 0 }: { perPage: number; page?: number }) => {
    try {
      const { products, pagination } =
        await service.products.requestByCategoryId(
          categoryId,
          {
            filter,
            perPage,
            page,
            ...sortingValues,
            set: productTileSet,
            score,
            sortChannel,
          },
          forceAddProducts,
        )

      return {
        pagination,
        productIds: products.map(p => p.id),
        products,
      }
    } catch (e) {
      if (onError) {
        onError(e)
      }

      return {
        products: [] as Product[],
        productIds: [] as string[],
        pagination: { current: 0, last: 0, total: 0 },
      }
    }
  }
}
